import React, { useContext, useEffect } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal } from "../styles/Emissao";
import TextField from "../../../../components/basics/TextFieldErp";
import useEmissaoController from "../controllers/EmissaoController";
import { EmissaoContext } from "../contexts/EmissaoContext";

const ModalEmissaoCobranca = ({
  modalCobrancaOpen,
  setModalCobrancaOpen,
  indexCharge,
}) => {
  const {
    handleAddCharge,
    chargeMaturities,
    setChargeMaturities,
    chargeError,
    setChargeError,
    handleEditCharge,
    chargeDueDate,
    setChargeDueDate,
    handleCalcChargeTable,
  } = useEmissaoController();

  const {
    itensTotalNfe,
    chargeValue,
    setChargeValue,
    itensTable,
    pagtoTableCobranca,
  } = useContext(EmissaoContext);

  useEffect(() => {
    if (indexCharge !== null) {
      handleEditCharge(indexCharge);
    } else {
      handleCalcChargeTable();
    }
    // eslint-disable-next-line
  }, [pagtoTableCobranca, itensTable, indexCharge, itensTotalNfe]);

  const handleClose = () => {
    setModalCobrancaOpen(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={modalCobrancaOpen}
      onClose={handleClose}
      aria-labelledby="dialog-cobranca"
    >
      <HeaderModal>
        <DialogTitle id="dialog-cobranca">
          <Chip label="COBRANÇA" bgcolor="primary" textcolor="white" />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container>
          <Grid container spacing={2}>
            <Grid item sm={6}>
              <TextField
                value={chargeValue}
                setValue={setChargeValue}
                mask="decimal"
                size="small"
                label="Valor"
                error={chargeError.chargeValue ? true : false}
                helperText={chargeError.chargeValue || ""}
              />
            </Grid>
            {indexCharge === null ? (
              <>
                <Grid item sm={6}>
                  <TextField
                    value={chargeMaturities}
                    setValue={setChargeMaturities}
                    size="small"
                    label="Vencimentos"
                    error={chargeError.chargeMaturities ? true : false}
                    helperText={chargeError.chargeMaturities || ""}
                  />
                </Grid>
              </>
            ) : (
              <Grid item sm={6}>
                <TextField
                  value={chargeDueDate}
                  setValue={setChargeDueDate}
                  type="date"
                  size="small"
                  label="Data de Vencimento"
                  error={chargeError.chargeDueDate ? true : false}
                  helperText={chargeError.chargeDueDate || ""}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          onClick={() => {
            handleAddCharge(setModalCobrancaOpen, setChargeError, indexCharge);
          }}
          label="incluir"
        />
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalEmissaoCobranca;
